import { Component, ViewEncapsulation } from '@angular/core'

@Component({
  selector: 'kdgh-page-subtitle',
  templateUrl: './page-subtitle.component.html',
  styleUrls: ['./page-subtitle.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PageSubtitleComponent {}
